import React, { useEffect, useMemo, useState } from "react";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { FaSpinner } from "react-icons/fa";
import { listarPatrocinadoresMatchMeet } from "./credenciamentoConteudosApi";

const animatedComponents = makeAnimated();
export const MAX_EMPRESAS_MATCH_MEET = 3;

const selectStyles = {
  control: (provided, state) => ({
    ...provided,
    minHeight: "2.85rem",
    borderRadius: 10,
    borderColor: state.isFocused ? "#00b5ad" : "rgba(80, 84, 86, 0.25)",
    borderWidth: 1.5,
    boxShadow: state.isFocused ? "0 0 0 3px rgba(0, 181, 173, 0.2)" : "none",
    "&:hover": {
      borderColor: state.isFocused ? "#00b5ad" : "rgba(80, 84, 86, 0.4)",
    },
    fontFamily: "inherit",
  }),
  multiValue: (provided) => ({
    ...provided,
    background: "rgba(0, 168, 155, 0.12)",
    borderRadius: 8,
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: "#0c1a44",
    fontWeight: 600,
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: "#00a89b",
    ":hover": {
      background: "rgba(0, 168, 155, 0.25)",
      color: "#0c1a44",
    },
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 20,
    borderRadius: 10,
    overflow: "hidden",
  }),
  option: (provided, state) => ({
    ...provided,
    background: state.isSelected
      ? "#00a89b"
      : state.isFocused
        ? "rgba(0, 181, 173, 0.12)"
        : "transparent",
    color: state.isSelected ? "#fff" : "#0c1a44",
    fontWeight: state.isSelected ? 600 : 500,
  }),
};

export default function PassoMatchMeet({ empresas, onChangeEmpresas }) {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState("");

  useEffect(() => {
    let cancelado = false;
    (async () => {
      setLoading(true);
      setErro("");
      try {
        const data = await listarPatrocinadoresMatchMeet();
        if (cancelado) return;
        if (!data?.ok) {
          setErro(data?.mensagem || "Não foi possível carregar as empresas.");
          setOptions([]);
          return;
        }
        const opts = (data.dados || []).map((p) => ({
          value: p.id,
          label: p.nome,
          nome: p.nome,
          logo: p.logo || null,
        }));
        setOptions(opts);
      } catch (err) {
        if (cancelado) return;
        console.error(err);
        setErro("Não foi possível carregar as empresas. Tente novamente.");
        setOptions([]);
      } finally {
        if (!cancelado) setLoading(false);
      }
    })();
    return () => {
      cancelado = true;
    };
  }, []);

  const limiteAtingido = empresas.length >= MAX_EMPRESAS_MATCH_MEET;

  const value = useMemo(
    () =>
      empresas.map((emp) => ({
        value: emp.id,
        label: emp.nome,
        nome: emp.nome,
        logo: emp.logo || null,
      })),
    [empresas],
  );

  const handleChange = (selectedOptions) => {
    if (!selectedOptions?.length) {
      onChangeEmpresas([]);
      return;
    }
    const limited = selectedOptions.slice(0, MAX_EMPRESAS_MATCH_MEET).map((opt) => ({
      id: opt.value,
      nome: opt.nome || opt.label,
      logo: opt.logo || null,
    }));
    onChangeEmpresas(limited);
  };

  return (
    <div className="c26-step-panel">
      <p className="c26-lead">
        Reservamos um espaço na agenda para que você também tenha a oportunidade
        de escolher com quem deseja realizar uma reunião. <br />
        Selecione até {MAX_EMPRESAS_MATCH_MEET} empresas e verificaremos a
        disponibilidade desse agendamento.
      </p>

      <div className="cc-match-field">
        <label className="c26-label" htmlFor="cc-match-empresas">
          Com qual empresa você gostaria de conversar durante o evento?{" "}
          <span className="cc-match-hint">
            (máx. {MAX_EMPRESAS_MATCH_MEET})
          </span>
          {limiteAtingido ? (
            <span className="cc-match-limite">
              {" "}
              — Limite de {MAX_EMPRESAS_MATCH_MEET} empresas atingido
            </span>
          ) : null}
        </label>

        {loading ? (
          <p className="cc-match-loading">
            <FaSpinner className="fa-spin" aria-hidden /> Carregando
            empresas…
          </p>
        ) : erro ? (
          <p className="cc-passo-vazio">{erro}</p>
        ) : (
          <>
            <Select
              inputId="cc-match-empresas"
              closeMenuOnSelect={false}
              components={animatedComponents}
              isMulti
              noOptionsMessage={() => "Nenhuma empresa encontrada"}
              options={options}
              placeholder={`Selecione até ${MAX_EMPRESAS_MATCH_MEET} empresas`}
              onChange={handleChange}
              value={value}
              menuPlacement="auto"
              styles={selectStyles}
              classNamePrefix="cc-match-select"
            />

            {limiteAtingido ? (
              <p className="c26-hint">
                Você selecionou o máximo de {MAX_EMPRESAS_MATCH_MEET} empresas.
                Para alterar, remova uma empresa da lista acima.
              </p>
            ) : (
              <p className="c26-hint">
                Selecionadas: {empresas.length}/{MAX_EMPRESAS_MATCH_MEET}
              </p>
            )}
          </>
        )}
      </div>
    </div>
  );
}
